import React, { useContext } from 'react'
import {
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  Divider,
  Menu,
  MenuItem,
} from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import dayjs from 'dayjs'
var classNames = require('classnames')

export const AccountTableRow = ({ user, onUserClick, options }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (choice) => {
    setAnchorEl(null)
  }

  const onRowClick = () => {
    onUserClick(user)
  }

  const onMenuItemClick = (option) => {
    handleClose()
    option.onClick()
  }

  return (
    <TableRow onClick={onRowClick} className="clickable" key={user.userId}>
      <TableCell component="th" scope="row">
        {user.firstName} {user.lastName}
      </TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>
        {dayjs(user.latestPolicyValidUntil).format(
          FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)
        )}
      </TableCell>
      <TableCell>
        <span
          className={classNames(
            'bold',
            { green: user.latestPolicyAutoRenew },
            { red: !user.latestPolicyAutoRenew }
          )}>
          {user.latestPolicyAutoRenew ? 'On' : 'Off'}
        </span>
      </TableCell>
      <TableCell>
        {user.latestQuote && user.latestQuote.status == 'ApprovalRequired'
          ? 'Referred'
          : user.status}
      </TableCell>
      <TableCell onClick={(e) => e.stopPropagation()}>
        <IconButton onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
          {options.map((option) => (
            <MenuItem key={option.text} onClick={() => onMenuItemClick(option)}>
              {option.text}
            </MenuItem>
          ))}
        </Menu>
      </TableCell>
    </TableRow>
  )
}
